import React, { useState } from "react";
import classes from "./ScheduleMobile.module.css";
import { Container, Row, Col } from "react-bootstrap";
import Colors from "../../../stories/assets/Colors";
import Fonts from "../../../stories/assets/Fonts";
import { Button } from "../../../stories/Button/Button";
import { InputWithSearchIcon } from "../../../stories/InputWithSearchIcon/InputWithSearchIcon";
import MobileCoachTodoLessonCard from "../../../stories/CoachTodoLessonCard/MobileCoachTodoLessonCard";
import MobileBottomTab from "../../../stories/MobileBottomTab/MobileBottomTab";
import { useHistory } from "react-router-dom";
import {
  bookingIconGray,
  HomeIconGray,
  messageIconGray,
  NotificationIconGray,
  ProfileIconGray,
  coachDemoImg,
} from "../../../constant/imagePath";
import FilterModal from "../../../components/Modals/CoachFlow/Schedule/Filter/FilterModal";
import CustomFullCalendar from "../../../stories/CustomFullCalendar";

const ScheduleMobile = ({ lessionData = [] }) => {
  const history = useHistory();
  const [menuItem, setMenuItem] = useState("schedule");
  const [isOpenFilter, setIsOpenFilter] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchType, setSearchType] = useState();
  const [isView, setIsView] = useState("day");

  const lessonRequests = [
    {
      user: {
        displayName: "Tyler",
        profile: coachDemoImg,
      },
      time: "12:30PM- 2:30PM",
      date: "Aug 16, 2021",
      location: "DeWitt Clinton Park, W 54th St, New York, NY",
      income: "64",
      timeLeft: "14:30:10",
      type: "upcoming",
      requestType: "1-on-1 Tennis lesson",
    },
    {
      user: {
        displayName: "Kate",
        profile: coachDemoImg,
      },
      time: "12:30PM- 2:30PM",
      date: "Aug 16, 2021",
      location: "DeWitt Clinton Park, W 54th St, New York, NY",
      income: "64",
      timeLeft: "14:30:10",
      type: "pending",
      requestType: "1-on-1 Tennis lesson",
    },
    {
      user: {
        displayName: "Tyler",
        profile: coachDemoImg,
      },
      time: "12:30PM- 2:30PM",
      date: "Aug 16, 2021",
      location: "DeWitt Clinton Park, W 54th St, New York, NY",
      income: "64",
      timeLeft: "14:30:10",
      type: "accepted",
      requestType: "1-on-1 Tennis lesson",
    },
  ];
  return (
    <div className={[classes.ScheduleScreen].join(" ")}>
      <Container fluid className={[classes.container].join(" ")}>
        <Row className={["g-0", classes.row, classes.pb32].join(" ")}>
          <Col sm={12} className={[classes.mb24].join(" ")}>
            <h2
              style={{
                ...Fonts.h2,
                color: Colors.neutralShadesOfNero,
                fontSize: "26px",
                lineHeight: "32px",
              }}
            >
              Schedule
            </h2>
          </Col>

          <Col sm={12}>
            <Row>
              <Col xs={7} sm={9} className={["pe-0", classes.mb24].join(" ")}>
                <InputWithSearchIcon
                  placeholder="Search"
                  isShowFilter={true}
                  onFilter={() => setIsOpenFilter(true)}
                  state={searchText}
                  setter={setSearchText}
                />
              </Col>
              <Col xs={5} sm={3} className={[classes.mb24].join(" ")}>
                <Button
                  label="Availability"
                  primary={true}
                  customStyle={{ width: "100%" }}
                />
              </Col>
            </Row>
          </Col>

          <Col sm={12}>
            {isView == "list" ? (
              lessionData?.map((item) => {
                return <MobileCoachTodoLessonCard lesson={item} />;
              })
            ) : (
              <CustomFullCalendar
                ScheduleData={lessionData}
                // startOfWeek={isView == "week" ?new Date(moment().startOf("week").format()) : undefined}
                calendarType={isView}
              />
            )}
          </Col>
        </Row>
      </Container>

      <div className={classes.BottomTab}>
        <MobileBottomTab state={menuItem} />
      </div>
      <FilterModal
        show={isOpenFilter}
        setShow={setIsOpenFilter}
        setIsView={setIsView}
        isView={isView}
        onClear={() => setIsView('day')}
      />
    </div>
  );
};
export default ScheduleMobile;
